module.exports = __webpack_public_path__ + "img/49200.c2af35e4.jpg";